import React from 'react';
import { DataManager } from "../../../../dataControls/DataManager";
import { ChecklistDataControl } from "../../../../dataControls/ChecklistDataControls";

import './StandardProductPopup.css';

export class StandardProductAssignCategoryPopup extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isValid: true
        };

        this.onControlBound = this.onControlBound.bind(this);
        this.onControlUnbound = this.onControlUnbound.bind(this);
        this.onValidated = this.onValidated.bind(this);

        this.dataManager = new DataManager(
            'standard-product',
            this.onControlBound,
            this.onControlUnbound,
            this.onValidated);
    }

    componentDidMount() {
        this.dataManager.init()
            .then(dataManager => {
                //1) load Data
                if (this.props.dataId) {

                    dataManager.loadContext(this.props.dataId)
                        .then(() => {
                            //2) bind Controls                           
                            dataManager.bindControls();
                        })
                        .catch(ex => {
                            window.Router.setNotFound();
                        });
                }
                else {
                    //2) bind Controls
                    dataManager.bindControls();
                }
            });
    }

    onControlBound(control, propertyName) {
        var value = this.dataManager.dataObject[propertyName];
        if (value) {
            control.setValue(value);
        }
    }

    onControlUnbound(control, propertyName) {
    }


    onValidated(isValid) {
        this.setState({
            isValid: isValid
        });
    }

    onSaveClick() {
        var self = this;
        self.dataManager.saveContext()
            .then(data => {
                self.props.popup.close();
                window.Alerts.showSuccess('Category Assignments have been saved');
            })
            .catch(error => {
                window.Alerts.showError('An error occurred while saving the Category Assignments');
            });
    }

    render() {
        return (
            <div className='standard-product-popup'>
                <p>Please select all industry categories this product should be associated with:</p>
                <ChecklistDataControl dataManager={this.dataManager} propertyName='categories' />
                <div className='buttons'>
                    <button className='btn btn-primary' onClick={() => { this.props.popup.close() }}>Cancel</button>
                    <button className='btn btn-secondary pull-right' disabled={!this.state.isValid} onClick={() => { this.onSaveClick() }}>Save</button>
                </div>
            </div>
        )
    }
}